export const GET_CITIES = 'getCities';
export const GET_CITY = 'getCity';
export const GET_UNIVERSITIES = 'getUniversities';
export const GET_UNIVERSITY = 'getUniversity';
